"use client";

import { useEffect } from "react";
import publishEventToSDK from "./publish-event-to-sdk";

/**
 * Publishes `contentLoaded` to the native SDK the moment this hook's host
 * component mounts on the client.
 *
 * Previously this awaited `document.fonts.ready`, which delayed the publish
 * until every custom font network request resolved — adding tens to hundreds
 * of ms on cold loads. The native SDK uses `contentLoaded` to hide its
 * loading spinner; the wait was meaningful spinner-overhang time. We rely on
 * skeleton + the real page paint to be the signal, not font readiness.
 */
const useOnLoadPublisher = (component: string) => {
  useEffect(() => {
    publishEventToSDK({ topic: "contentLoaded", data: { component } });
  }, [component]);
};

export default useOnLoadPublisher;
